module.exports = __webpack_public_path__ + "static/media/Avatar.e66c364d.png";